const mapToAddress = require('./mapToAddress');
const mapFromAddress = require('./mapFromAddress');
const validateAddress = require('./validateAddress');

module.exports = {
  mapToAddress,
  mapFromAddress,
  validateAddress,
};
